import { css } from 'styled-components';

export const scrollMarginToSection = css`
    scroll-margin-top: calc(var(--sticky-header-height) + var(--club-bar-banner-height));
`;
